import {createContext,useContext} from 'solid-js';

const LayoutContext = createContext();

interface ILayoutContent {
	pageName: string;
	setPageName: (name:string)=>void;
	setSettingsPageName: (name:string)=>void,
	setExpandDesktopNav: (expand:boolean)=>void,
	imageFolder: string;
	setImageFolder: (name:string)=>void,
	setPageStyleTags: (names:string[])=>void
}

export function LayoutProvider(P:{children} & ILayoutContent)
{
	return (
		<LayoutContext.Provider value={P}>
			{P.children}
		</LayoutContext.Provider>
	);
}

export function initLayout(pageName:string,settingsPageName:string,imageFolder:string=null,expandDesktopNav=false)
{
	const layout = useContext(LayoutContext);
	layout.setPageName(pageName);
	layout.setSettingsPageName(settingsPageName);
	layout.setImageFolder(imageFolder);
	layout.setExpandDesktopNav(expandDesktopNav);
}

export function useLayout():ILayoutContent
{
	return useContext(LayoutContext);
}

